// extracted by mini-css-extract-plugin
export default {"background":"Contact_background__HVP23","icon":"Contact_icon__MAuA2","btn":"Contact_btn__0WlbU"};